<div class="loginContainer" [ngClass]="{ 'is-mobile-view': isMobileView }">
    <div class="graphic" [ngClass]="{ 'is-mobile-view': isMobileView }">
        <span class="login_logo_container" *ngIf="!isB2CMode"
            ><img class="logo" src="{{ imageRootFolder }}Claro_logo_whit_on_blue.svg"
        /></span>
        <span class="login_topic_container" *ngIf="isMobileView">
            <span class="login_topic">{{ "login.joinHR" | translate }}</span>
            <span class="login_topic_bold">{{ "login.revolution" | translate }}</span>
        </span>
        <img
            class="login_image"
            *ngIf="!isMobileView"
            [style.height]="isB2CMode ? '100%' : null"
            [src]="imageRootFolder + (isB2CMode ? 'login_b2c.png' : 'login.png')" />
    </div>

    <div class="login_form" [ngClass]="{ 'is-mobile-view': isMobileView }">
        <div class="tokenLogin_localeSelector">
            <img
                class="login_image"
                class="tokenLogin_localeImg"
                src="{{ imageRootFolder }}locale_en_US.png"
                (click)="setFormLocale(localeValues.en_US)" />
            <img
                class="login_image"
                class="tokenLogin_localeImg"
                src="{{ imageRootFolder }}locale_he_IL.png"
                (click)="setFormLocale(localeValues.he_IL)" />
        </div>
        <div class="formBottomPart" *ngIf="!isTokenValidated" [ngClass]="{ 'is-mobile-view': isMobileView }">
            <div class="text">
                <span class="subTitle">{{ "tokenLogin.welcomeMessage" | translate }}</span>
                <span class="title">{{ "tokenLogin.loginDirective" | translate }}</span>
            </div>
            <div class="userFormFields" [ngClass]="{ 'is-mobile-view': isMobileView }">
                <mat-form-field class="longField" appearance="fill">
                    <mat-label>{{ "tokenLogin.accessToken" | translate }}</mat-label>
                    <input matInput [(ngModel)]="accessToken" />
                </mat-form-field>
                <span class="tokenLogin_errorMessage" *ngIf="lastLoginFailedOnCreds">{{
                    "tokenLogin.wrongToken" | translate
                }}</span>
                <span class="loginButtons" [ngClass]="{ 'is-mobile-view': isMobileView }">
                    <button mat-raised-button class="submitButton" (click)="submitToken()">
                        {{ "login.submitButton" | translate }}
                    </button>
                    <button
                        mat-button
                        class="switchLoginButton"
                        [ngClass]="{ 'is-mobile-view': isMobileView }"
                        (click)="switchToLogin()">
                        {{ "tokenLogin.switchToLoginButton" | translate }}
                    </button>
                </span>
            </div>
        </div>
        <div class="formBottomPart" *ngIf="isTokenValidated" [ngClass]="{ 'is-mobile-view': isMobileView }">
            <div class="text">
                <span class="subTitle" [ngClass]="{ 'is-mobile-view': isMobileView }">{{
                    "tokenLogin.welcomeMessage" | translate
                }}</span>
                <span class="title" [ngClass]="{ 'is-mobile-view': isMobileView }">{{
                    "tokenLogin.regitrationDirective" | translate
                }}</span>
            </div>
            <form class="login_form" [formGroup]="tokenLoginForm" (ngSubmit)="registerUser()">
                <span
                    class="tokenLogin_errorMessage"
                    *ngIf="tokenFormUserEmail && tokenFormUserEmail.errors && tokenFormUserEmail.errors.pattern"
                    >{{ "tokenLogin.invalidMail" | translate }}</span
                >
                <span class="tokenLogin_errorMessage" *ngIf="registrationFailed">{{ errMessage }}</span>
                <div class="userFormFieldsContainer" [ngClass]="{ 'is-mobile-view': isMobileView }">
                    <div class="userFormFields" [ngClass]="{ 'is-mobile-view': isMobileView }">
                        <span class="userName">
                            <mat-form-field class="tokenLogin_smallFormField" appearance="fill">
                                <mat-label>{{ "tokenLogin.firstNameLabel" | translate }}</mat-label>
                                <input matInput formControlName="tokenFormFirstName" required />
                            </mat-form-field>
                            <mat-form-field class="tokenLogin_smallFormField" appearance="fill">
                                <mat-label>{{ "tokenLogin.lastNameLabel" | translate }}</mat-label>
                                <input matInput formControlName="tokenFormLastName" required />
                            </mat-form-field>
                        </span>
                        <span class="userName">
                            <mat-form-field class="tokenLogin_smallFormField" appearance="fill">
                                <mat-label>{{
                                    (isB2CMode ? "tokenLogin.orgNameLabel_b2c" : "tokenLogin.orgNameLabel") | translate
                                }}</mat-label>
                                <input matInput formControlName="tokenFormUserInputOrg" [required]="!isB2CMode" />
                            </mat-form-field>
                            <mat-form-field class="tokenLogin_smallFormField" appearance="fill">
                                <mat-label>{{
                                    (isB2CMode ? "tokenLogin.currentRoleLabel_b2c" : "tokenLogin.currentRoleLabel")
                                        | translate
                                }}</mat-label>
                                <input matInput formControlName="tokenFormUserInputRole" [required]="!isB2CMode" />
                            </mat-form-field>
                        </span>
                        <mat-form-field class="userProfile_longFIeld" appearance="fill">
                            <mat-label>{{ "tokenLogin.mailAddressLabel" | translate }}</mat-label>
                            <input
                                matInput
                                formControlName="tokenFormUserEmail"
                                class="userProfile_longFIeld"
                                required />
                        </mat-form-field>
                        <span class="userName" [ngClass]="{ 'is-mobile-view': isMobileView }">
                            <mat-form-field
                                class="tokenLogin_smallFormField"
                                [ngClass]="{ 'is-mobile-view': isMobileView }"
                                appearance="fill">
                                <mat-label>{{ "tokenLogin.languageSelectLabel" | translate }}</mat-label>
                                <mat-select [(value)]="selectedLocale" formControlName="tokenFormLocale" required>
                                    <mat-option value="en-US">{{ getLocaleForPresentation("en-US") }}</mat-option>
                                    <mat-option value="he-IL">{{ getLocaleForPresentation("he-IL") }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field
                                class="tokenLogin_smallFormField"
                                [ngClass]="{ 'is-mobile-view': isMobileView }"
                                appearance="fill">
                                <mat-label>{{ "tokenLogin.genderSelectLabel" | translate }}</mat-label>
                                <mat-select formControlName="tokenFormGender" required>
                                    <mat-option [value]="1">{{ "personal.male" | translate }}</mat-option>
                                    <mat-option [value]="2">{{ "personal.female" | translate }}</mat-option>
                                    <mat-option [value]="3">{{
                                        "personal.nonBinary" | translate
                                    }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </span>
                        <span class="userName" [ngClass]="{ 'is-mobile-view': isMobileView }">
                            <mat-form-field
                                class="tokenLogin_smallFormField"
                                [ngClass]="{ 'is-mobile-view': isMobileView }"
                                appearance="fill">
                                <mat-label>{{
                                    (isB2CMode ? "tokenLogin.roleSelectLabel_b2c" : "tokenLogin.roleSelectLabel")
                                        | translate
                                }}</mat-label>
                                <mat-select formControlName="tokenFormRole" [required]="!isB2CMode">
                                    <mat-option [value]="1">{{
                                        "tokenLogin.roleSelectOption_yes" | translate
                                    }}</mat-option>
                                    <mat-option [value]="2">{{
                                        "tokenLogin.roleSelectOption_no" | translate
                                    }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </span>
                        <div class="userProfile_userFormFields" [ngClass]="{ 'is-mobile-view': isMobileView }">
                            <mat-form-field class="userProfile_longFIeld" appearance="fill">
                                <mat-label
                                    class="tokenLogin_passwordLabel"
                                    [ngClass]="{ 'is-mobile-view': isMobileView }"
                                    >{{ "tokenLogin.password" | translate }}</mat-label
                                >
                                <input
                                    matInput
                                    formControlName="password"
                                    [type]="hidePassword ? 'password' : 'text'" />
                                <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword">
                                    <mat-icon>{{ hidePassword ? "visibility_off" : "visibility" }}</mat-icon>
                                </button>
                            </mat-form-field>
                            <mat-form-field class="userProfile_longFIeld" appearance="fill">
                                <mat-error
                                    class="tokenLogin_passwordNotMatchText"
                                    *ngIf="tokenLoginForm.hasError('passwordDiffer')">
                                    {{ "tokenLogin.passwordsDoNotMatchError" | translate }}
                                </mat-error>
                                <mat-label
                                    class="tokenLogin_passwordLabel"
                                    [ngClass]="{ 'is-mobile-view': isMobileView }"
                                    >{{ "tokenLogin.repeatPassword" | translate }}</mat-label
                                >
                                <input
                                    matInput
                                    formControlName="confirmPassword"
                                    [type]="hidePassword ? 'password' : 'text'"
                                    [errorStateMatcher]="matcher" />
                                <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword">
                                    <mat-icon>{{ hidePassword ? "visibility_off" : "visibility" }}</mat-icon>
                                </button>
                            </mat-form-field>
                            <span class="userProfile_passwordPolicy">{{ "personal.passwordPolicy" | translate }}</span>
                        </div>
                        <div class="userProfile_buttonsContainer">
                            <button
                                mat-raised-button
                                *ngIf="!isSubmitting"
                                class="userProfile_updateButton"
                                type="submit"
                                [disabled]="!tokenLoginForm.valid">
                                {{ "tokenLogin.registerButton" | translate }}
                            </button>
                            <mat-spinner class="tokenLogin_submitSpinner" *ngIf="isSubmitting"></mat-spinner>
                            <ng-container *ngIf="!isSubmitting">
                                <div class="tokenLogin_divider"><span>{{ "tokenLogin.orDivider" | translate }}</span></div>
                                <button
                                    mat-button
                                    class="switchLoginButton tokenLogin_alreadyRegistered"
                                    type="button"
                                    (click)="switchToLogin()">
                                    {{ "tokenLogin.switchToLoginButton" | translate }}
                                </button>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="tokenLogin_footer">
            <a (click)="openPrivacyPolicy()">
                {{ "tokenLogin.footerPrivacyPolicy" | translate }}
            </a>
            <span class="tokenLogin_footer_separator">|</span>
            <a (click)="openTermsOfUse()">
                {{ "tokenLogin.footerTermsOfUse" | translate }}
            </a>
        </div>
    </div>
</div>
